import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { queryClient } from './app/queryClient'
import { RefreshProvider } from './app/RefreshContext'
import { router } from './app/router'
import { AuthGate } from './auth/AuthGate'
import { ToastProvider } from './components/ui/Toast'
import './styles/global.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthGate>
          <RefreshProvider>
            <RouterProvider router={router} />
          </RefreshProvider>
        </AuthGate>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
)
